export const windowUtils = {
  redirectTo: (url: string): void => {
    window.location.assign(url);
  },

  openInNewWindow: (
    url?: string,
    target = '_blank',
    features = 'noopener,noreferrer',
  ): Window | null => {
    if (!url) {
      return null;
    }
    return window.open(url, target, features);
  },

  getPathname: (): string => {
    return window.location.pathname;
  },

  getSearch: (): string => {
    return window.location.search;
  },

  getHost: (): string => {
    return window.location.host;
  },

  getHref: (): string => {
    return window.location.href;
  },

  getHostname: (): string => {
    return window.location.hostname;
  },

  reload: (): void => {
    window.location.reload();
  },

  getOrigin: (): string => {
    return window.location.origin;
  },

  getPort: (): string => {
    return window.location.port;
  },

  getProtocol: (): string => {
    return window.location.protocol;
  },
};
